import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ExamenDefinitionSummaryFindAllService} from '../../service/examenDefinitionSummaryFindAll.service';
import {FormValueModel} from '../../../../../form/form/value/api/entity/formValue.model';
import {
  AbstractFieldInputTypeHandlerComponent
} from '../../../../../../components/common/field/field-input/type-handler/abstract-field-input-type-handler.component';
import {FormDefinitionFieldModel} from '../../../../../form/definition/field/api/entity/formDefinitionField.model';

@Component({
  templateUrl: './exam-form-definition-form-value-json-handler.component.html',
  viewProviders: [ExamenDefinitionSummaryFindAllService]
})
export class ExamFormDefinitionFormValueJsonHandlerComponent
    extends AbstractFieldInputTypeHandlerComponent<UntypedFormGroup> {

  constructor(private formBuilder: UntypedFormBuilder,
              public service: ExamenDefinitionSummaryFindAllService) {
    super();
    service.findAll();
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): UntypedFormGroup {
    return this.formBuilder.group({
      examFormDefinitionName: this.formBuilder.control(undefined, formDefinitionField.required ? Validators.required : [])
    });
  }

  synchronizeValue(): string {
    return JSON.stringify(this.jsonControl.value);
  }

  initiateForm(formValue: FormValueModel): void {
    if (formValue?.value) {
      this.jsonControl.patchValue(
        JSON.parse(formValue.value));
    }
  }


}
